// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DKbu","name":"styles_name__XW0RL","phone":"styles_phone__1RRtI"};